// SalesShark — Non-translatable static assets (URLs, images, videos, brand, team meta)

export const LINKS = {
    consultation:
        "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0bOCZiN1gXvwS-EOuOJBO_8b4GrA60viB9m0v2OBsCHLCP_bwnKVcNw6uOxyIPUBXSWag87WS3",
    about: "/#rolunk",
    references: "/#referenciak",
    contact: "/#kapcsolat",
    companyPdf:
        "https://www.salesshark.eu/_files/ugd/f901ad_04ff0b43477d4bd694d5f47108205188.pdf",
    facebook: "https://www.facebook.com/",
    linkedin: "https://www.linkedin.com/",
    twitter: "https://twitter.com/",
};

export const BRAND = {
    logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/kot7vsgn_SALESSHARK%20CSAK%20Logo2%20%282%29.webp",
};

export const IMAGES = {
    heroHome:
        "https://static.wixstatic.com/media/f901ad_21b7eabf878e4523be138d597382a133f000.jpg/v1/fill/w_1905,h_993,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/f901ad_21b7eabf878e4523be138d597382a133f000.jpg",
    heroHomeVideo:
        "https://video.wixstatic.com/video/f901ad_21b7eabf878e4523be138d597382a133/1080p/mp4/file.mp4",
    heroServices:
        "https://static.wixstatic.com/media/11062b_6d0e9f4366e54f978b475c62f35749d4f000.jpg/v1/fill/w_1905,h_993,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_6d0e9f4366e54f978b475c62f35749d4f000.jpg",
    heroServicesVideo:
        "https://video.wixstatic.com/video/11062b_6d0e9f4366e54f978b475c62f35749d4/1080p/mp4/file.mp4",
    resultsPortrait:
        "https://static.wixstatic.com/media/f901ad_c318ecd1b21a42158529a5b275449c05f000.jpg/v1/fill/w_720,h_1000,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/f901ad_c318ecd1b21a42158529a5b275449c05f000.jpg",
    resultsVideo:
        "https://video.wixstatic.com/video/f901ad_c318ecd1b21a42158529a5b275449c05/720p/mp4/file.mp4",
    goal: "https://static.wixstatic.com/media/f901ad_55afdf4cb0244d8fac9edc23ece8b242f000.jpg/v1/fill/w_720,h_900,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_55afdf4cb0244d8fac9edc23ece8b242f000.jpg",
};

export const PARTNER_LOGOS = [
    { name: "WHC Slovakia", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/huqz4kk8_whc_hu_logo-removebg-preview.png" },
    { name: "Intretech", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/s7eygdms_g178-removebg-preview.png" },
    { name: "MOTIM Zrt.", src: "https://customer-assets-cm19k8pv.emergentagent.net/job_shark-modern/artifacts/fdae9r3r_images__1_-removebg-preview.png" },
];

// Quick services — icon per tile + which tiles show country badges
export const QUICK_SERVICE_ICONS = [
    "Database", "CalendarClock", "PhoneCall", "Headphones", "UserCheck",
    "Globe2", "Sparkles", "Megaphone", "Share2",
];
export const QUICK_SERVICE_HAS_COUNTRIES = [true, false, false, false, false, true, false, false, false];

// Team — non-translatable data (name, image, email, phone, spoken languages).
// Translatable role + bio come from the current language dictionary.
export const TEAM_STATIC = [
    {
        name: "Somogyi Antónia",
        image: "https://static.wixstatic.com/media/f901ad_b3599b517c1b4ee9b1faead4d9b54863~mv2.jpg/v1/fill/w_600,h_800,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_b3599b517c1b4ee9b1faead4d9b54863~mv2.jpg",
        email: "antonia@globefox.eu",
        phone: "+421 917 705 884",
        phoneHref: "tel:+421917705884",
        languages: ["HU", "SK", "CZ", "EN"],
    },
    {
        name: "Korcz Antal",
        image: "https://static.wixstatic.com/media/f901ad_78ff97dac635487f988df99f7352ade8~mv2.png/v1/fill/w_600,h_1050,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_78ff97dac635487f988df99f7352ade8~mv2.png",
        email: "antal@globefox.eu",
        phone: "+36 70 369 3173",
        phoneHref: "tel:+36703693173",
        languages: ["HU", "EN"],
    },
];

// Backwards-compat aliases (may be used elsewhere)
export const TEAM = TEAM_STATIC;

// Which services section on /services carries which video/poster
export const SERVICE_MEDIA = {
    cegadatbazis: {
        video: "https://video.wixstatic.com/video/11062b_1cc774bf94324bc3a7ecd1c154047cc3/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/11062b_1cc774bf94324bc3a7ecd1c154047cc3f000.jpg/v1/fill/w_720,h_1150,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_1cc774bf94324bc3a7ecd1c154047cc3f000.jpg",
    },
    email: {
        video: "https://video.wixstatic.com/video/11062b_8c2f2cd1fd91409e9366464172ed633d/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/11062b_8c2f2cd1fd91409e9366464172ed633df000.jpg/v1/fill/w_720,h_1140,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_8c2f2cd1fd91409e9366464172ed633df000.jpg",
    },
    phone: {
        video: "https://video.wixstatic.com/video/f901ad_4f3436298b0f4145b88a3042d98a64bc/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/f901ad_4f3436298b0f4145b88a3042d98a64bcf000.jpg/v1/fill/w_720,h_1200,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/f901ad_4f3436298b0f4145b88a3042d98a64bcf000.jpg",
    },
    staff: {
        video: "https://video.wixstatic.com/video/f901ad_458882048e00437db05b72947bc59f3a/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/f901ad_458882048e00437db05b72947bc59f3af000.jpg/v1/fill/w_720,h_1200,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/f901ad_458882048e00437db05b72947bc59f3af000.jpg",
    },
    marketing: {
        video: "https://video.wixstatic.com/video/11062b_5408cffcf6c34f679f8a1ca1a4e0c0d4/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/11062b_5408cffcf6c34f679f8a1ca1a4e0c0d4f000.jpg/v1/fill/w_720,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_5408cffcf6c34f679f8a1ca1a4e0c0d4f000.jpg",
    },
    expansion: {
        video: "https://video.wixstatic.com/video/11062b_3e2f37c297534f9ead156265242fbca8/720p/mp4/file.mp4",
        poster: "https://static.wixstatic.com/media/11062b_3e2f37c297534f9ead156265242fbca8f000.jpg/v1/fill/w_720,h_1200,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_3e2f37c297534f9ead156265242fbca8f000.jpg",
    },
};

// Country flag lookup used across pages
export const FLAG = { HU: "🇭🇺", SK: "🇸🇰", CZ: "🇨🇿", AT: "🇦🇹" };
